import _jsx from '@babel/runtime/helpers/jsx';
import { useState } from 'react';
import 'prop-types';
import { Button } from '@andes/button';
import { Pill } from '@andes/badge';
import { jsxs, Fragment } from 'react/jsx-runtime';
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a() {
      if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function () {
        return n[k];
      }
    });
  });
  return a;
}
var productComparisonTable = {};
var _span, _span2;
const getButtonText = (showAll, viewMoreText, viewLessText) => {
  if (showAll) {
    return /*#__PURE__*/jsxs(Fragment, {
      children: [viewLessText, " ", _span || (_span = /*#__PURE__*/_jsx("span", {
        className: "chevron chevron--up"
      }))]
    });
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [viewMoreText, " ", _span2 || (_span2 = /*#__PURE__*/_jsx("span", {
      className: "chevron chevron--down"
    }))]
  });
};
const renderButton = (isButtonDisplayed, showAll, setShowAll, viewMoreText, viewLessText, namespace) => {
  if (!isButtonDisplayed) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace}__button__container`
  }, void 0, /*#__PURE__*/_jsx(Button, {
    onClick: () => setShowAll(!showAll),
    hierarchy: "transparent",
    size: "medium"
  }, void 0, getButtonText(showAll, viewMoreText, viewLessText)));
};
const showPrice = price => {
  return price ? /*#__PURE__*/_jsx(Pill, {
    hierarchy: "quiet"
  }, void 0, price.split(',')[0]) : null;
};
var _td;
const ProductComparisonTable$1 = props => {
  const {
    title,
    initialRowsShowedCount,
    viewMoreText,
    viewLessText,
    keyDetails,
    productDetails
  } = props;
  const namespace = "seo-ui-product-comparison-table";
  const isButtonDisplayed = initialRowsShowedCount < keyDetails.length;
  const [showAll, setShowAll] = useState(false);
  const showRow = rowNumber => showAll || rowNumber < initialRowsShowedCount;
  const renderTableHeader = () => /*#__PURE__*/_jsx("thead", {
    className: `${namespace}__thead`
  }, void 0, _td || (_td = /*#__PURE__*/_jsx("td", {
    className: `${namespace}__thead__tr__header__td`
  })), productDetails.map((item, index) => renderProductDetailHeaderCell(item, index)));
  const renderProductAttribute = (productDetail, key, columIndex, index) => {
    const {
      attributes
    } = productDetail;
    const attributeValue = attributes[key];
    return /*#__PURE__*/_jsx("td", {
      className: `${namespace}__tbody__tr__td`
    }, `product-attribute-${key}-${columIndex}-${index}`, /*#__PURE__*/_jsx("div", {}, void 0, attributeValue));
  };
  const renderKeyRowData = (key, text, rowIndex) => /*#__PURE__*/_jsx("tr", {
    className: showRow(rowIndex) ? `${namespace}__tbody__tr` : `${namespace}__tbody__tr hidden`
  }, `row-${key}-${rowIndex}`, /*#__PURE__*/_jsx("td", {
    className: `${namespace}__tbody__tr__td`
  }, `product-header-${key}-${rowIndex}`, /*#__PURE__*/_jsx("div", {}, void 0, text)), productDetails.map((productDetail, index) => renderProductAttribute(productDetail, key, rowIndex, index)));
  const renderTitleAndPrice = (title, price) => /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("h2", {}, void 0, title), /*#__PURE__*/_jsx("div", {
      className: `${namespace}__thead__tr__header__td__div__price`
    }, void 0, showPrice(price))]
  });
  const renderProductDetailHeaderCell = (productDetail, index) => {
    const {
      title,
      price
    } = productDetail;
    return /*#__PURE__*/_jsx("td", {
      className: `${namespace}__thead__tr__header__td`
    }, `product-detail-${index}`, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__thead__tr__header__td__div`
    }, void 0, productDetail.url ? /*#__PURE__*/_jsx("a", {
      className: `${namespace}__thead__tr__header__td__div__link`,
      href: productDetail.url,
      title: title
    }, void 0, renderTitleAndPrice(title, price)) : renderTitleAndPrice(title, price)));
  };
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace}`
  }, void 0, /*#__PURE__*/_jsx("h2", {
    className: `${namespace}__title`
  }, void 0, title), /*#__PURE__*/_jsx("div", {
    className: `${namespace}__table-container`
  }, void 0, /*#__PURE__*/_jsx("table", {
    className: `${namespace}__table`
  }, void 0, renderTableHeader(), /*#__PURE__*/_jsx("tbody", {
    className: `${namespace}__tbody`
  }, void 0, keyDetails.map((_ref, index) => {
    let {
      key,
      text
    } = _ref;
    return renderKeyRowData(key, text, index);
  })))), renderButton(isButtonDisplayed, showAll, setShowAll, viewMoreText, viewLessText, namespace));
};
ProductComparisonTable$1.displayName = "ProductComparisonTable";
var ProductComparisonTable$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: ProductComparisonTable$1
});
var require$$0 = /*@__PURE__*/getAugmentedNamespace(ProductComparisonTable$2);
const namespace = "seo-ui-single-product-table";
const SingleProductTable$1 = _ref => {
  var _h, _h2;
  let {
    title = "",
    initialRowsShowedCount = 5,
    viewMoreText,
    viewLessText,
    keyDetails = [],
    productDetails
  } = _ref;
  const {
    attributes = [],
    title: productTitle = "",
    price = "",
    url = ""
  } = productDetails;
  const isButtonDisplayed = initialRowsShowedCount < keyDetails.length;
  const [showAll, setShowAll] = useState(false);
  const renderContent = () => /*#__PURE__*/jsxs(Fragment, {
    children: [productTitle && (_h || (_h = /*#__PURE__*/_jsx("h3", {
      className: `${namespace}__header__title`
    }, void 0, productTitle))), price && /*#__PURE__*/_jsx("p", {
      className: `${namespace}__price`
    }, void 0, showPrice(price))]
  });
  const renderTable = () => /*#__PURE__*/_jsx("div", {
    className: `${namespace}`
  }, void 0, title && (_h2 || (_h2 = /*#__PURE__*/_jsx("h2", {
    className: `${namespace}__title`
  }, void 0, title))), /*#__PURE__*/_jsx("div", {
    className: `${namespace}__header`
  }, void 0, url ? /*#__PURE__*/_jsx("a", {
    href: url,
    title: productTitle
  }, void 0, renderContent()) : renderContent()), /*#__PURE__*/_jsx("table", {
    className: `${namespace}__table`
  }, void 0, /*#__PURE__*/_jsx("tbody", {
    className: `${namespace}__table-body`
  }, void 0, keyDetails.map((_ref2, index) => {
    let {
      key,
      text
    } = _ref2;
    return /*#__PURE__*/_jsx("tr", {
      className: `${namespace}__table-row ${!showAll && index >= initialRowsShowedCount ? "hidden" : ""}`
    }, index, /*#__PURE__*/_jsx("th", {
      className: `${namespace}__table-row-column`,
      scope: "row"
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}__table-header-container`
    }, void 0, text)), /*#__PURE__*/_jsx("td", {
      className: `${namespace}__table-row-column`
    }, void 0, /*#__PURE__*/_jsx("span", {
      className: `${namespace}__table-column-value`
    }, void 0, attributes[key])));
  }))));
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace}__wrapper`
  }, void 0, renderTable(), renderButton(isButtonDisplayed, showAll, setShowAll, viewMoreText, viewLessText, namespace));
};
var SingleProductTable$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: SingleProductTable$1
});
var require$$1 = /*@__PURE__*/getAugmentedNamespace(SingleProductTable$2);
const ProductComparisonTable = require$$0.default;
const SingleProductTable = require$$1.default;
var ProductComparisonTable_1 = productComparisonTable.ProductComparisonTable = ProductComparisonTable;
var SingleProductTable_1 = productComparisonTable.SingleProductTable = SingleProductTable;
export { ProductComparisonTable_1 as ProductComparisonTable, SingleProductTable_1 as SingleProductTable, productComparisonTable as default };
